import { useMemo, useState } from "react";

export const DEFAULT_PAGE_SIZE = 10;
export const PAGE_SIZE_OPTIONS = ["10", "25", "50", "100"];

/**
 * Controlled AntD Table pagination. A fresh `pagination={{ ... }}` object
 * literal on every render makes the Table treat page size / current page as
 * reset each time (a well-known AntD footgun) — this keeps both in real
 * state so picking "50 / page" actually sticks instead of snapping back.
 */
export default function useTablePagination(defaultPageSize = DEFAULT_PAGE_SIZE) {
  const [current, setCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(defaultPageSize);

  const pagination = useMemo(() => ({
    current,
    pageSize,
    showSizeChanger: true,
    pageSizeOptions: PAGE_SIZE_OPTIONS,
    onChange: (nextPage, nextPageSize) => {
      setCurrent(nextPage);
      if (nextPageSize !== pageSize) setPageSize(nextPageSize);
    },
  }), [current, pageSize]);

  const resetPage = () => setCurrent(1);

  return { pagination, resetPage, current, pageSize };
}
